import React from 'react'

import DropDownCourse from '..'
import type { IDropdownCourseContent } from '../DropdownCourse'
import type { IChildrenHandler } from '../types'

type ITooltip = Omit<IDropdownCourseContent, 'type' | 'children'> & {
  children: IChildrenHandler
}

const TooltipCourse: React.FC<ITooltip> = ({ children, overlay, ...restProps }) => {
  const [isOpen, setIsOpen] = React.useState(false)

  return !overlay ? (
    children
  ) : (
    <DropDownCourse
      onVisibleChange={setIsOpen}
      visible={isOpen}
      {...restProps}
      overlay={overlay}
      type='tooltip'
      flip
      shift
    >
      {children}
    </DropDownCourse>
  )
}

export default TooltipCourse
